interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, Math.min(current - 2, total - 4));
  const end = Math.min(total, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const btnBase =
    "flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm font-medium transition-colors";

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
        className={`${btnBase} border border-background-200 text-foreground-600 hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>
      {start > 1 && (
        <>
          <button type="button" onClick={() => onChange(1)} className={`${btnBase} border border-background-200 text-foreground-600 hover:bg-background-100`}>
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-400">…</span>}
        </>
      )}
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${btnBase} ${
            p === current
              ? "bg-accent-500 text-background-50"
              : "border border-background-200 text-foreground-600 hover:bg-background-100"
          }`}
        >
          {p}
        </button>
      ))}
      {end < total && (
        <>
          {end < total - 1 && <span className="px-1 text-foreground-400">…</span>}
          <button type="button" onClick={() => onChange(total)} className={`${btnBase} border border-background-200 text-foreground-600 hover:bg-background-100`}>
            {total}
          </button>
        </>
      )}
      <button
        type="button"
        disabled={current >= total}
        onClick={() => onChange(current + 1)}
        className={`${btnBase} border border-background-200 text-foreground-600 hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}